<script setup lang="ts">
import { Label, type LabelProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<LabelProps & { class?: string }>()
</script>

<template>
	<Label
		v-bind="props"
		:class="
			cn(
				'text-foreground block text-left text-sm font-medium tracking-tight',
				props.class,
			)
		"
	>
		<slot />
	</Label>
</template>
